export function addCurrencyFormat(amount: any): string {
  amount = Number(amount);
  if (isNaN(amount)) return '';
  const str = parseFloat(amount.toFixed(2)).toString().split('.');
  if (str[0].length >= 5) {
    str[0] = Number(str[0]).toLocaleString('en-US');
  }
  if (str[1] && str[1].length >= 5) {
    str[1] = str[1].replace(/(\d{3})/g, '$1 ');
  }
  return '$' + str.join('.');
}

export function removeCurrencyFormat(amount: any): string {
  if (amount === undefined) return '';
  return amount.replace(/[^0-9.]+/g, '');
}

export function addPercentageFormat(amount: any): string {
  amount = Number(amount);
  if (isNaN(amount)) return '';
  return parseFloat((amount * 100).toFixed(3)).toString();
}

export function removePercentageFormat(amount: any): string {
  amount = Number(amount);
  if (isNaN(amount)) return '';
  return (amount / 100).toFixed(5).toString();
}
